// extracted by mini-css-extract-plugin
export default {"title":"CreateOrganizationPopupTitle_title__LXSmz","subtitle":"CreateOrganizationPopupTitle_subtitle__I3xh9"};